import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/SearchOutlined';
import { tokens } from '../../theme';
import { IPatient, IPrescription, patientsBaseRoute } from "../../types";

interface RecentPatientsProps {
  prescriptions: IPrescription[];
}

const extractPatients = (prescriptions?: IPrescription[]): IPatient[] => {
  if (!prescriptions) {
    return [];
  }

  return prescriptions
    .map(rx => rx.patient)
    .filter((patient, index, array) => array.findIndex(x => x.id === patient.id) === index);
};

const DashboardRecentPatients = ({ prescriptions }: RecentPatientsProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const patients = extractPatients(prescriptions);
  const total = patients?.length;

  return (
    <Card sx={{
      backgroundColor: colors.primary[400] 
    }}>
      <CardHeader 
        title={
          <Typography 
            variant="h5" 
            fontWeight="bold" 
            color={colors.greenAccent[500]}
          >
            Patients Count: {total}
          </Typography>
        } 
      />
      
      <CardContent>
        <div style={{ width: '100%', height: 300 }}>
          <TableContainer 
            sx={{
              width: '100%',
              height: 260
            }}
          >
            <Table stickyHeader={true}>
              <TableHead>
                <TableRow>
                  <TableCell>Full Name</TableCell>
                  <TableCell align="right">OHIP</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {patients.map((patient: IPatient) => (
                  <TableRow key={patient.id} hover onClick={() => navigate(`${patientsBaseRoute}/${patient.id}`)}>
                    <TableCell>{`${patient.firstName} ${patient.lastName}`}</TableCell>
                    <TableCell align="right">{patient.personalHealthNumber}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box 
            sx={{
              marginTop: '8px'
            }}
          >
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: "14px",
                fontWeight: "bold",
                padding: "8px 14px",
              }}
              component={Link}
              to={patientsBaseRoute}
            >
              <SearchIcon sx={{ mr: "8px" }} />
              Search All Patients
            </Button>
          </Box>
        </div>
      </CardContent>
    </Card>
  );
};

export default DashboardRecentPatients;